export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  status: '连载中' | '已完结';
  chapters: number;
  updatedAt: string;
  tags: string[];
  views: number;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'love', name: '恋爱甜宠', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '奇幻世界冒险，开启异世界之旅' },
  { slug: 'urban', name: '都市生活', icon: 'ri-building-line', description: '都市情感与职场生活真实写照' },
  { slug: 'action', name: '动作热血', icon: 'ri-fire-line', description: '热血战斗场面，燃爆你的视觉' },
  { slug: 'mystery', name: '悬疑推理', icon: 'ri-search-eye-line', description: '烧脑悬疑剧情，挑战你的推理能力' },
  { slug: 'historical', name: '古风穿越', icon: 'ri-ancient-gate-line', description: '穿越时空的古代浪漫传奇故事' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常漫画，治愈你的心情' },
  { slug: 'bl', name: '耽美BL', icon: 'ri-star-line', description: '精美画风的耽美漫画精选合集' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '她的私密日记',
    author: '金智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20romance%20cover%20art%2C%20soft%20pastel%20warm%20tones%2C%20young%20couple%20in%20gentle%20embrace%2C%20cherry%20blossom%20petals%20floating%2C%20dreamy%20romantic%20atmosphere%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20composition%2C%20light%20cream%20background%20with%20subtle%20gradient%2C%20elegant%20and%20refined%20artwork&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'love',
    description: '一段不为人知的秘密恋情，在首尔繁华都市的背景下悄然展开。女主智秀是一名普通上班族，却意外与公司最受欢迎的男神产生交集，一场甜蜜又曲折的办公室恋情就此上演。画风细腻唯美，剧情扣人心弦，是韩国漫画中不可错过的恋爱甜宠佳作。',
    rating: 4.8,
    status: '连载中',
    chapters: 86,
    updatedAt: '2026-08-04',
    tags: ['恋爱', '办公室', '甜宠', '治愈'],
    views: 1285000,
  },
  {
    id: 2,
    title: '异世界剑圣',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20action%20cover%2C%20warrior%20with%20glowing%20sword%20in%20epic%20battle%20pose%2C%20magical%20energy%20effects%20in%20warm%20golden%20and%20crimson%20tones%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20illustration%20style%2C%20dynamic%20composition%2C%20cream%20background%20with%20epic%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '平凡少年穿越到剑与魔法的世界，凭借现代人的智慧与不屈意志，一步步成长为举世无双的剑圣。宏大的世界观设定，紧张刺激的战斗场面，以及令人热血沸腾的成长历程，让这部韩国漫画成为奇幻冒险类的不朽经典。',
    rating: 4.9,
    status: '连载中',
    chapters: 124,
    updatedAt: '2026-08-03',
    tags: ['奇幻', '穿越', '战斗', '成长'],
    views: 2150000,
  },
  {
    id: 3,
    title: '江南夜未眠',
    author: '朴秀英',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20urban%20life%20cover%2C%20fashionable%20young%20woman%20in%20Seoul%20cityscape%20at%20night%2C%20neon%20lights%20reflection%2C%20sophisticated%20modern%20aesthetic%2C%20Korean%20webtoon%20art%20style%2C%20warm%20amber%20and%20soft%20cream%20color%20palette%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'urban',
    description: '在首尔最繁华的江南区，三个性格迥异的女性在职场与爱情中寻找自我。她们的故事交织着欢笑与泪水，展现了当代都市女性的独立与坚韧。细腻的画风配合深入人心的情节，是一部不可多得的韩国都市漫画佳作。',
    rating: 4.7,
    status: '已完结',
    chapters: 95,
    updatedAt: '2026-07-20',
    tags: ['都市', '职场', '女性', '情感'],
    views: 980000,
  },
  {
    id: 4,
    title: '热血高校',
    author: '崔俊浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20school%20cover%2C%20group%20of%20students%20in%20dynamic%20fighting%20stance%2C%20intense%20energy%2C%20warm%20crimson%20and%20golden%20color%20accents%2C%20Korean%20webtoon%20illustration%20style%2C%20powerful%20composition%2C%20cream%20background%20with%20dramatic%20impact&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'action',
    description: '在一所问题学生云集的高中里，新来的转校生凭借一身傲骨与超强实力，掀起了一场席卷全校的风暴。拳拳到肉的格斗场面，真挚感人的兄弟情谊，韩国漫画特有的热血气质在这部作品中展现得淋漓尽致。',
    rating: 4.6,
    status: '连载中',
    chapters: 152,
    updatedAt: '2026-08-04',
    tags: ['校园', '格斗', '热血', '兄弟'],
    views: 1870000,
  },
  {
    id: 5,
    title: '第七夜的秘密',
    author: '尹淑贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20thriller%20cover%2C%20shadowy%20figure%20in%20dim%20moonlight%2C%20suspenseful%20atmosphere%2C%20dark%20warm%20amber%20tones%20with%20deep%20shadows%2C%20Korean%20webtoon%20mystery%20art%20style%2C%20minimalist%20composition%2C%20cream%20and%20charcoal%20color%20palette&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'mystery',
    description: '连环失踪案背后隐藏着怎样的惊天秘密？天才女侦探与神秘男子联手追查真相，却在第七个夜晚发现了令人毛骨悚然的线索。精心设计的谜题、环环相扣的剧情，这部韩国悬疑漫画将带你进入一个充满反转的推理世界。',
    rating: 4.9,
    status: '已完结',
    chapters: 72,
    updatedAt: '2026-06-15',
    tags: ['悬疑', '推理', '侦探', '犯罪'],
    views: 1630000,
  },
  {
    id: 6,
    title: '花间令：穿越公主',
    author: '韩智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20historical%20romance%20cover%2C%20beautiful%20princess%20in%20traditional%20Korean%20hanbok%2C%20cherry%20blossoms%20and%20ancient%20palace%20background%2C%20soft%20warm%20pink%20and%20cream%20tones%2C%20Korean%20webtoon%20illustration%20style%2C%20elegant%20and%20graceful%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'historical',
    description: '现代女医生意外穿越到古代朝鲜，成为了一位不受宠的公主。凭借现代医学知识，她在宫廷中开辟出自己的一片天地，同时与三位身份迥异的男子展开了一段跨越时空的浪漫情缘。画风华美精致，是韩国古风穿越漫画中的顶级之作。',
    rating: 4.8,
    status: '连载中',
    chapters: 108,
    updatedAt: '2026-08-02',
    tags: ['穿越', '古风', '宫廷', '医学'],
    views: 2340000,
  },
  {
    id: 7,
    title: '废柴逆袭记',
    author: '宋民奎',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20comedy%20cover%2C%20goofy%20yet%20charming%20male%20protagonist%20with%20exaggerated%20expression%2C%20bright%20playful%20art%20style%2C%20warm%20yellow%20and%20cream%20tones%2C%20Korean%20webtoon%20humor%20style%2C%20lively%20and%20energetic%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'comedy',
    description: '作为一个公认的废柴，他在被所有人看不起的情况下，意外获得了神秘系统。从此开启了一段啼笑皆非的逆袭人生。夸张的表情、爆笑的桥段、出人意料的剧情反转，这部韩国搞笑漫画绝对是解压治愈的不二之选。',
    rating: 4.5,
    status: '连载中',
    chapters: 198,
    updatedAt: '2026-08-04',
    tags: ['搞笑', '系统', '逆袭', '日常'],
    views: 3210000,
  },
  {
    id: 8,
    title: '月光之约',
    author: '林秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20BL%20manhwa%20cover%2C%20two%20handsome%20young%20men%20under%20moonlight%2C%20gentle%20and%20tender%20atmosphere%2C%20soft%20silver%20and%20cream%20color%20tones%2C%20Korean%20webtoon%20illustration%20style%2C%20elegant%20and%20emotional%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'bl',
    description: '在月光映照的校园里，两个少年的命运被一根看不见的线紧密相连。从最初的误会与冲突，到后来的相知与相守，他们共同经历了青春最美好的时光。画风清新唯美，情感描写细腻动人，是韩国耽美漫画中的清流之作。',
    rating: 4.7,
    status: '已完结',
    chapters: 64,
    updatedAt: '2026-05-30',
    tags: ['校园', '纯爱', '治愈', '成长'],
    views: 1560000,
  },
  {
    id: 9,
    title: '霸总的契约恋人',
    author: '赵允儿',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20manhwa%20romance%20cover%2C%20elegant%20CEO%20man%20in%20luxury%20setting%20with%20beautiful%20woman%2C%20sophisticated%20warm%20champagne%20and%20rose%20gold%20tones%2C%20Korean%20webtoon%20art%20style%2C%20refined%20and%20romantic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'love',
    description: '为了拯救家族企业，她与冷酷霸总签订了一纸契约婚姻。原以为只是一场交易，却在朝夕相处中渐渐被对方的温柔打动。霸道总裁与倔强女孩的经典搭配，加上韩国漫画特有的唯美画风，让这部作品甜到了无数读者的心坎里。',
    rating: 4.6,
    status: '连载中',
    chapters: 74,
    updatedAt: '2026-08-04',
    tags: ['霸总', '契约', '甜宠', '都市'],
    views: 1980000,
  },
  {
    id: 10,
    title: '暗黑骑士传说',
    author: '姜泰宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%2C%20armored%20dark%20knight%20with%20glowing%20eyes%20in%20epic%20pose%2C%20gothic%20atmosphere%2C%20warm%20crimson%20and%20deep%20shadow%20tones%2C%20Korean%20webtoon%20style%2C%20powerful%20and%20mysterious%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    description: '在被黑暗势力吞噬的大陆上，最后一位暗黑骑士背负着诅咒与使命前行。他既不是英雄，也不是恶魔，却在命运的十字路口做出了改变世界的选择。史诗般的叙事、震撼的视觉呈现，这部韩国奇幻漫画为读者构建了一个令人叹为观止的暗黑世界。',
    rating: 4.8,
    status: '连载中',
    chapters: 136,
    updatedAt: '2026-08-03',
    tags: ['黑暗', '骑士', '史诗', '魔法'],
    views: 1760000,
  },
  {
    id: 11,
    title: '便利店夜班',
    author: '郑恩彩',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20Korean%20manhwa%20cover%2C%20cozy%20convenience%20store%20at%20night%20with%20warm%20lighting%2C%20young%20cashier%20with%20gentle%20smile%2C%20nostalgic%20atmosphere%2C%20soft%20warm%20cream%20and%20amber%20tones%2C%20Korean%20webtoon%20style%2C%20peaceful%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'urban',
    description: '深夜便利店里的温暖故事。每一个走进店里的人，都带着自己独特的烦恼与秘密，而值夜班的店员成为了他们短暂人生的见证者。平淡中见真情，这部韩国都市漫画用最朴实的笔触描绘了城市夜归人的百态人生。',
    rating: 4.7,
    status: '已完结',
    chapters: 48,
    updatedAt: '2026-07-10',
    tags: ['都市', '治愈', '日常', '人文'],
    views: 890000,
  },
  {
    id: 12,
    title: '格斗之王',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20martial%20arts%20cover%2C%20fighter%20in%20intense%20combat%20pose%20with%20dynamic%20motion%20lines%2C%20arena%20background%2C%20warm%20crimson%20and%20golden%20energy%20effects%2C%20Korean%20webtoon%20action%20style%2C%20powerful%20and%20explosive%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'action',
    description: '地下格斗场的传奇选手，为了寻找失踪的妹妹而重返擂台。每一场比赛都是生死较量，每一个对手背后都隐藏着惊天阴谋。酣畅淋漓的打斗分镜，紧张刺激的剧情节奏，这部韩国动作漫画将格斗漫画的水准提升到了新的高度。',
    rating: 4.6,
    status: '连载中',
    chapters: 112,
    updatedAt: '2026-08-01',
    tags: ['格斗', '热血', '复仇', '地下'],
    views: 1450000,
  },
];

export const faqs = [
  {
    question: '韩漫画网的漫画都是免费阅读的吗？',
    answer: '是的，韩漫画网所有韩国漫画均提供在线免费阅读服务。我们致力于为漫画爱好者打造一个无需付费即可畅享高清韩漫的优质平台，让每一位用户都能尽情享受韩国漫画带来的视觉盛宴。',
  },
  {
    question: '网站上的韩国漫画更新频率如何？',
    answer: '我们与多家韩国漫画版权方保持密切合作，确保热门连载漫画能够同步更新。一般来说，连载中的韩国漫画每周至少更新一到两次，部分热门作品甚至可以实现日更，让您追更不停歇。',
  },
  {
    question: '漫画的画质清晰吗？可以在手机上阅读吗？',
    answer: '韩漫画网提供的所有韩国漫画均为高清画质，经过专业优化处理，无论是在电脑端还是手机端阅读，都能获得清晰流畅的视觉体验。网站采用响应式设计，自动适配各种屏幕尺寸。',
  },
  {
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过首页的搜索功能直接搜索漫画名称，也可以通过分类导航按类型浏览。我们还提供热门推荐和最新更新等板块，帮助您快速发现优质好看的韩国漫画内容。',
  },
  {
    question: '网站上的漫画有没有广告？',
    answer: '韩漫画网注重用户体验，所有漫画阅读页面均保持清爽简洁，不会在阅读过程中弹出干扰性广告。我们仅在部分非核心区域放置少量不影响阅读的展示内容，确保您的阅读体验不受打扰。',
  },
];

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getRelatedComics(currentId: number, category: string, count: number = 4): Comic[] {
  return comics
    .filter((c) => c.category === category && c.id !== currentId)
    .slice(0, count);
}

export function getLatestComics(count: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, count);
}

export function getPopularComics(count: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, count);
}

export function getRecommendedComics(count: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, count);
}